import React from 'react'

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import Banner2 from "../components/Banner2";
import About from '../components/About';
import Social from '../components/Social';

const SobreMi = () => {
  return (
    <div>
      <Navbar />
      <Banner2 heading="SOBRE MÍ" text="Experiencia, formación y más" />
      <About/>
      <Social/>
      <Footer />
    </div>
  )
}

export default SobreMi